import { Injectable, Injector } from '@angular/core';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { LoginService } from '../api/login.service';
import { OrderService } from '../api/order.service';
import { LoaderService } from '../loader.service';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private injector: Injector, private loader: LoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const authService = this.injector.get(LoginService);
    const tokenReq = request.clone({
      // headers: request.headers.set('Authorization', authService.getToken()),
      headers: new HttpHeaders({
        // Accept: 'application/json',
        Authorization: 'Bearer ' + authService.getUserToken(),
      }),
    });
    return next.handle(tokenReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // logout / redirect to login
        }
        return throwError(() => error);
      }),
      finalize(() => {
        this.loader.hide();
      })
    );
  }
}
